import { render, staticRenderFns } from "./TopicBoardAttachments.vue?vue&type=template&id=735433fc&"
import script from "./TopicBoardAttachments.vue?vue&type=script&lang=js&"
export * from "./TopicBoardAttachments.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports